<template>
  <div id="SectionHeroBCorp">
    <UIContainer class="SectionHeroBCorp__container">
      <template #left>
        <!-- Trust Badge -->
        <div class="SectionHeroBCorp__trust-badge">
          <UIIcon
            class="SectionHeroBCorp__trust-icon"
            name="checkCircleOutline"
          />
          <span class="SectionHeroBCorp__trust-text">
            Trusted by 100+ companies
          </span>
        </div>

        <!-- Main Headline -->
        <h1 class="SectionHeroBCorp__title">
          Carbon Accounting for
          <UITitleHighlight> B Corp </UITitleHighlight>
        </h1>
        <!-- Description -->
        <p class="SectionHeroBCorp__description">
          Boost your environmental score by setting Net Zero targets and
          buidiling a Climate Transition Plan
        </p>

        <!-- Social Proof -->
        <div class="SectionHeroBCorp__social-proof">
          <SectionSocialProof />
        </div>

        <!-- CTA Button -->
        <div class="SectionHeroBCorp__cta">
          <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
            Schedule a call
          </UIButton>
        </div>
      </template>

      <template #right>
        <div class="SectionHeroBCorp__image-container">
          <img
            class="SectionHeroBCorp__image"
            src="../assets/hero/bg.avif"
            alt="BCorp hero background"
            fetchpriority="high"
            loading="eager"
          />
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'
import SectionSocialProof from '@/views/components/sections/SectionSocialProof.vue'
import UITitleHighlight from '@/views/components/ui/typography/UITitleHighlight.vue'
</script>

<style lang="scss" scoped>
#SectionHeroBCorp {
  .SectionHeroBCorp__container {
    padding: 2rem 2rem 3rem;
    position: relative;

    @include md {
      padding: 2.875rem 3rem 6rem;
    }
  }

  .SectionHeroBCorp__image-container {
    display: none;
    position: relative;

    @include md {
      display: block;
    }
  }

  .SectionHeroBCorp__image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    border-radius: 1.5rem;
  }

  .SectionHeroBCorp__trust-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background-color: $newcolor-primary-pale;
    color: $color-ui-brand-700;
    padding: 0.5rem 1rem;
    border-radius: 2rem;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
    border: 1px solid $color-ui-brand-200;
  }

  .SectionHeroBCorp__trust-icon {
    --size: 1rem;
    --color: #{$newcolor-primary-main};
  }

  .SectionHeroBCorp__title {
    font-weight: 600;
    font-size: 2.25rem;
    line-height: 1.2;
    letter-spacing: -2%;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1.5rem;

    @include md {
      font-size: 3.75rem;
    }
  }

  // .SectionHeroBCorp__title-highlight removed in favor of UITitleHighlight

  .SectionHeroBCorp__description {
    @include font-size-18px();
    color: $color-ui-gray-cool-600;
    line-height: 1.6;
    margin-bottom: 2rem;
    max-width: 32rem;

    strong {
      font-weight: 600;
      color: $color-ui-gray-cool-900;
    }
  }

  .SectionHeroBCorp__social-proof {
    margin-bottom: 2rem;
  }

  .SectionHeroBCorp__cta {
    display: flex;
    align-items: center;
    justify-content: center;

    @include md {
      justify-content: flex-start;
    }
  }
}
</style>
